import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ChoicesService {
    resetChoicesSelection: boolean = false;

    private emitResetChoiceSelection = new BehaviorSubject<boolean>(this.resetChoicesSelection);
    resetChoiceSelectionEmitted$ = this.emitResetChoiceSelection.asObservable();
   
    emitResetChoices(reset: any) {
        this.emitResetChoiceSelection.next(reset);
    }

    constructor() { }
}
